function isoDate(offsetDays) {
    const d = new Date();
    d.setDate(d.getDate() + offsetDays);

    return d.toISOString().slice(0, 10);
}

function approvingDoctor() {
    return {
        external_id: 'XNB-DOC-1088',
        name: 'Dr. Kovács Anna',
        approved_at: new Date().toISOString(),
    };
}

// The bodies are built from the current form values.
export const examples = [
    {
        key: 'minimal',
        label: '1. Minimális terápia létrehozás (POST)',
        method: 'POST',
        pathKey: 'store',
        build: (ctx) => ({
            schema_version: '1.0',
            external_ref: ctx.externalRef,
            patient: { xmed_master_patient_id: ctx.patientId },
            approving_doctor: approvingDoctor(),
            therapy: {
                starts_on: isoDate(0),
                ends_on: isoDate(13),
                timezone: 'Europe/Budapest',
            },
            components: [
                {
                    component_version_id: ctx.componentVersionId,
                    parameters: {
                        measured_data_type: 'steps',
                        evaluation_rule: 'daily_sum_gte',
                        target_value: 6000,
                    },
                    daily_frequency: 1,
                    time_of_day: 'anytime',
                },
            ],
        }),
    },
    {
        key: 'full',
        label: '2. Teljes terápia több komponenssel (POST)',
        method: 'POST',
        pathKey: 'store',
        build: (ctx) => ({
            schema_version: '1.0',
            external_ref: `${ctx.externalRef}-FULL`,
            patient: { xmed_master_patient_id: ctx.patientId },
            approving_doctor: approvingDoctor(),
            therapy: {
                starts_on: isoDate(0),
                ends_on: isoDate(27),
                timezone: 'Europe/Budapest',
            },
            components: [
                {
                    component_version_id: ctx.componentVersionId,
                    parameters: {
                        medicine_id: 45812,
                        medicine_name: 'Metilprednizolon 16 mg',
                        dose_mg: 32,
                        measured_data_type: 'medicine',
                        evaluation_rule: 'medicine_entry',
                    },
                    daily_frequency: 2,
                    time_of_day: 'morning',
                },
                {
                    component_version_id: ctx.componentVersionId,
                    parameters: {
                        medicine_id: 45812,
                        medicine_name: 'Metilprednizolon 16 mg',
                        dose_mg: 16,
                        measured_data_type: 'medicine',
                        evaluation_rule: 'medicine_entry',
                    },
                    starts_on: isoDate(7),
                    ends_on: isoDate(27),
                    daily_frequency: 1,
                    time_of_day: 'specific',
                    specific_time: '08:00',
                    weekdays: [1, 3, 5],
                    is_optional: false,
                },
            ],
        }),
    },
    {
        key: 'modify',
        label: '3. Terápia módosítása, rövidebb záródátum (PATCH)',
        method: 'PATCH',
        pathKey: 'update',
        build: () => ({
            schema_version: '1.0',
            approving_doctor: approvingDoctor(),
            therapy: {
                ends_on: isoDate(6),
                timezone: 'Europe/Budapest',
            },
        }),
    },
    {
        key: 'lifecycle',
        label: '4. Életciklus lépés, szüneteltetés (POST)',
        method: 'POST',
        pathKey: 'lifecycle',
        build: () => ({
            schema_version: '1.0',
            action: 'pause',
            reason: 'A páciens kórházi kezelés alatt áll.',
        }),
    },
    {
        key: 'invalid',
        label: '5. Szándékosan hibás létrehozás, 422 (POST)',
        method: 'POST',
        pathKey: 'store',
        // Past start date, no approving doctor and an empty component list.
        build: (ctx) => ({
            schema_version: '1.0',
            external_ref: `${ctx.externalRef}-BAD`,
            patient: { xmed_master_patient_id: ctx.patientId },
            therapy: {
                starts_on: isoDate(-30),
                ends_on: isoDate(-40),
                timezone: 'Nem/Letezo',
            },
            components: [],
        }),
    },
];
